// Etapas del motor de tiempos (so=300) y su nombre en palabras: una sola fuente para
// el cronómetro del Editor y Estudio de tiempos (UX-COPY-01: sin enums crudos).

export const STAGE_KINDS = [
  'elaboracion',
  'revision',
  'aprobacion',
  'capacitacion',
  'espera_de_vigencia',
] as const;
export type StageKind = (typeof STAGE_KINDS)[number];

const LABELS: Readonly<Record<StageKind, string>> = {
  elaboracion: 'Elaboración',
  revision: 'Revisión',
  aprobacion: 'Aprobación',
  capacitacion: 'Capacitación',
  espera_de_vigencia: 'Espera de vigencia',
};

export function stageKindLabel(kind: StageKind): string {
  return LABELS[kind];
}
